import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ProductCard {
    productUrl: string;
    productImageUrl: string;
    inStock: boolean;
}

export interface ProductCardModal extends ProductCard {
    openModal: boolean;
}

interface GenericModalProps {
    modalType: string;
    paywalledClassName: string;
    product: ProductCard | null;
    next?: {
        type: string | null;
        href?: string | null;
    } | null;
}

export interface GenericModal extends GenericModalProps {
    openModal: boolean;
}

export interface SendToAppModalSlice {
    OOSModalIsOpen: boolean;
    productCard: ProductCardModal;
    genericModal: GenericModal;
}

const sendToAppModal = createSlice({
    name: "sendToAppModal",
    initialState: {
        OOSModalIsOpen: false,
        productCard: {
            productUrl: "",
            openModal: false,
        },
        genericModal: {
            openModal: false,
            modalType: "",
            paywalledClassName: "",
            product: null,
            next: null,
        },
    } as SendToAppModalSlice,
    reducers: {
        openOOSModal(state): void {
            state.OOSModalIsOpen = true;
        },
        closeOOSModal(state): void {
            state.OOSModalIsOpen = false;
        },
        openProductCardModal(state, action: PayloadAction<ProductCard>): void {
            state.productCard = {
                productUrl: action.payload.productUrl,
                productImageUrl: action.payload.productImageUrl,
                inStock: action.payload.inStock,
                openModal: true,
            };
        },
        closeProductCardModal(state): void {
            state.productCard = {
                productUrl: "",
                productImageUrl: "",
                inStock: false,
                openModal: false,
            };
        },
        openGenericModal(state, action: PayloadAction<GenericModalProps>): void {
            state.genericModal = {
                openModal: true,
                modalType: action.payload.modalType,
                paywalledClassName: action.payload.paywalledClassName,
                product: action.payload.product,
                next: action.payload.next,
            };
        },
        closeGenericModal(state): void {
            state.genericModal = {
                openModal: false,
                modalType: "",
                paywalledClassName: "",
                product: null,
                next: null,
            };
        },
    },
});

export const {
    openOOSModal,
    closeOOSModal,
    openProductCardModal,
    closeProductCardModal,
    openGenericModal,
    closeGenericModal,
} = sendToAppModal.actions;
export default sendToAppModal.reducer;
